import React from 'react';
import { Copy } from 'lucide-react';

/**
 * SolutionField — single labeled field inside SolutionDrawer.
 * Extracted to a stable component to avoid React remount issues on every render.
 */
export default function SolutionField({
  label,
  path,
  value,
  multiline,   // undefined | true | 'json'
  hindi,
  editMode,
  onChange,
  onCopy,
}) {
  const isJson = multiline === 'json';
  const displayValue = typeof value === 'object' ? JSON.stringify(value, null, 2) : (value ?? '');

  return (
    <div className="mb-3">
      <div className="flex items-center justify-between mb-1">
        <label className="text-[10px] uppercase tracking-widest text-gold/70 font-semibold">{label}</label>
        <button
          type="button"
          onClick={() => onCopy(value)}
          className="text-[10px] text-gold hover:text-gold/70 flex items-center gap-1"
        >
          <Copy className="w-3 h-3" /> Copy
        </button>
      </div>

      {editMode ? (
        multiline ? (
          <textarea
            value={displayValue}
            onChange={(e) => {
              let v = e.target.value;
              if (isJson) {
                try { v = JSON.parse(e.target.value); } catch (_) { /* keep string, will re-parse on approve */ }
              }
              onChange(path, v);
            }}
            rows={isJson ? 8 : 3}
            className={`w-full px-3 py-2 bg-black/40 border border-gold/30 rounded text-sm font-mono ${hindi ? 'font-body' : ''} focus:border-gold focus:outline-none`}
          />
        ) : (
          <input
            type="text"
            value={displayValue}
            onChange={(e) => onChange(path, e.target.value)}
            className={`w-full px-3 py-2 bg-black/40 border border-gold/30 rounded text-sm ${hindi ? 'font-body' : ''} focus:border-gold focus:outline-none`}
          />
        )
      ) : (
        <div className={`px-3 py-2 bg-black/30 border border-gold/15 rounded text-sm text-text-main break-words ${hindi ? 'font-body' : ''} ${isJson ? 'font-mono text-xs' : ''}`}>
          {typeof value === 'object' ? (
            <pre className="whitespace-pre-wrap">{JSON.stringify(value, null, 2)}</pre>
          ) : displayValue || <span className="text-text-muted italic">empty</span>}
        </div>
      )}
    </div>
  );
}
